import React, { useEffect } from 'react';
import {
  CurrencySelector,
  useCurrencyConfigContext,
} from '@amzn/aaccurrency-visualisation-ui';
import { formatLocale } from 'src/providers/PantherLocalizationProvider/mbm';
import { CurrencySwitcherPublisher } from 'src/commons/utils/metrics';
import { currencyofViewSwitch } from 'src/commons/utils/helpers';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';

const CurrencyVisualisation: React.VFC = () => {
  const { selectedCurrency, currencyList } = useCurrencyConfigContext();
  const { config: internalChromeConfig } = useInternalChromeConfigContext();

  // The currency-visualisation module ships no type declarations (see the
  // TS7016 on its import), so the applied-currency shape is declared locally
  // from the only field this handler reads.
  const onApplyChange = (newCurrency: { code?: string } | undefined) => {
    if (newCurrency?.code) {
      currencyofViewSwitch(selectedCurrency.code, newCurrency.code);
    }
  };

  // Derived, not an early return, because the useEffect below must run on every
  // render. selectedCurrency/currencyList come from context and can arrive after
  // the first render, so bailing out before the hook made the hook count vary
  // between renders.
  const shouldRender = !(
    selectedCurrency === undefined ||
    (Array.isArray(currencyList) && currencyList.length === 0)
  );

  useEffect(() => {
    if (!shouldRender) return;
    CurrencySwitcherPublisher.publishCounterMonitor('currecyOfViewRendered', 1);
  }, [shouldRender]);

  if (!shouldRender) {
    return null;
  }

  return (
    <CurrencySelector
      id="aac-chrome-currency-switcher"
      locale={formatLocale(internalChromeConfig.locale)}
      onApplyChange={onApplyChange}
    />
  );
};

export default CurrencyVisualisation;
